module.exports = __webpack_public_path__ + "fonts/Inter-100-latin7.260c81a.woff2";